import React, { useState, useEffect } from "react";
import Sidebar from "../../../Components/Home/Sidebar";
import Header from "../../../Components/Header/Header";
import Footer from "../../../Components/Footer/Footer";
import DomesticPackages from "../../../Components/Home/Pakages/DomesticPakages";
import InternationalPakages from "../../../Components/Home/Pakages/InternationalPakages";
import EuropePakages from "../../../Components/Home/Pakages/EuropePakages";
import ReligiousPakages from "../../../Components/Home/Pakages/ReligiousPakages";
import domesticImg from "../../../Images/domestic.jpg"
import internationalImg from "../../../Images/international.jpg"
import europeImg from "../../../Images/europe.webp"
import religiousImg from "../../../Images/religious.jpg"





function ShowPakages() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [isOpen, setIsOpen] = useState(false);

 
  const slides = [
    {
      img: domesticImg, 
      title: "Domestic Packages"
    },
    {
      img: internationalImg, 
      title: "International Packages"
    },
     {
      img: religiousImg, 
      title: "Religious Pakages"
    },
     {
      img: europeImg, 
      title: "Europe Pakages"
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000); 

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="h-screen flex flex-col">
      <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div
        className={`transition-all duration-300 mt-[72px] 
          ${isOpen ? "ml-0 sm:ml-56" : "ml-0 sm:ml-16"}
        `}
      >
        <Header isOpen={isOpen} setIsOpen={setIsOpen} />

         
        <div>
          <div
            className="w-full h-96 bg-cover bg-center flex items-center justify-center transition-all duration-700"
            style={{
              backgroundImage: `url(${slides[currentSlide].img})`,
            }}
          >
            
            <h2 className="text-center text-white font-bold text-4xl px-6 py-2 rounded-lg bg-black/40">
              {slides[currentSlide].title}
            </h2>
          </div>
        </div>

         
        <DomesticPackages/>
        <InternationalPakages/>
        <EuropePakages/>
        <ReligiousPakages/>

        <Footer />
      </div>

      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 sm:hidden z-30"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </div>
  );
}

export default ShowPakages;
